import React from "react";
import { Link } from "react-router-dom";
import { getLandingConfig } from "./applicationLandings";
import ExperienceLandingSections from "../Experience/ExperienceLandingSections";
import "./Applications.css";

const LANDING_SLUGS = {
  organization: "organizations",
  creator: "creators",
  project: "projects",
};

/**
 * Public apply landing — hero, overview, benefits, requirements + agreement notice.
 * When Admin publishes an Experience Page (platform scope, slug organizations|creators|projects),
 * that page replaces the hardcoded body SSOT; Apply CTA remains via actions.
 */
export default function ApplicationLandingPage({ applicationType }) {
  const config = getLandingConfig(applicationType);
  const slug = LANDING_SLUGS[applicationType] || applicationType;

  const applyCta = (
    <div className="apply-landing__cta-row community-page__shell" style={{ marginTop: "1rem" }}>
      <Link className="btn btn-danger apply-landing__cta" to={config.applyPath}>
        {config.cta}
      </Link>
    </div>
  );

  return (
    <div className="community-page apply-landing">
      <ExperienceLandingSections
        scope="platform"
        slug={slug}
        actions={applyCta}
      >
        <header className="community-page__hero apply-landing__hero">
          <div className="community-page__shell">
            <p className="community-page__eyebrow">{config.eyebrow}</p>
            <h1 className="community-page__title">{config.title}</h1>
            <p className="community-page__lede">{config.lede}</p>
            <div className="apply-landing__cta-row">
              <Link className="btn btn-danger apply-landing__cta" to={config.applyPath}>
                {config.cta}
              </Link>
            </div>
          </div>
        </header>

        <main className="community-page__shell apply-landing__main">
          <section className="apply-landing__section" aria-labelledby="apply-overview">
            <h2 id="apply-overview">{config.overviewTitle}</h2>
            <p>{config.overview}</p>
            <h3 className="apply-landing__subhead">{config.examplesTitle}</h3>
            <ul className="apply-landing__examples">
              {config.examples.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="apply-landing__section" aria-labelledby="apply-benefits">
            <h2 id="apply-benefits">{config.benefitsTitle}</h2>
            <div className="apply-landing__benefits">
              {config.benefits.map((benefit) => (
                <article key={benefit.title} className="apply-landing__benefit">
                  <h3>{benefit.title}</h3>
                  <p>{benefit.body}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="apply-landing__section" aria-labelledby="apply-requirements">
            <h2 id="apply-requirements">{config.requirementsTitle}</h2>
            <ul className="apply-landing__requirements">
              {config.requirements.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p className="apply-landing__notice" role="note">
              Submission of an application does not guarantee approval.
            </p>
            <div className="apply-landing__cta-row">
              <Link className="btn btn-danger apply-landing__cta" to={config.applyPath}>
                {config.cta}
              </Link>
            </div>
          </section>
        </main>
      </ExperienceLandingSections>
    </div>
  );
}

export function OrganizationLandingPage() {
  return <ApplicationLandingPage applicationType="organization" />;
}

export function CreatorLandingPage() {
  return <ApplicationLandingPage applicationType="creator" />;
}

export function ProjectLandingPage() {
  return <ApplicationLandingPage applicationType="project" />;
}
